import JSZip from "jszip";
import { saveAs } from "file-saver";

export interface ImageFile {
  name: string;
  dataUrl: string;
}

export const zipImages = (filesToBeZipped: ImageFile[]) => {
    const zip = new JSZip();

    for (let s = 0; s < filesToBeZipped.length; s++) {
        const base64 = filesToBeZipped[s].dataUrl.replace(
            "data:image/png;base64,",
            ""
        );
        zip.file(filesToBeZipped[s].name, base64, { base64: true });
    }

    return new Promise<Blob>((resolve, reject) => {
        zip
            .generateAsync({ type: "blob" })
            .then((content) => {
                resolve(content);
            })
            .catch((reason: any) => {
                reject(reason);
            });
    });
};

export const downloadFile = (filename: string, content: Blob) => {
    saveAs(content, filename);
};

export const zipAndDownloadImages = (
    filename: string,
    filesToBeZipped: ImageFile[]
) => {
    return new Promise<void>((resolve, reject) => {
        zipImages(filesToBeZipped)
            .then((content: Blob) => {
                downloadFile(filename, content);
                resolve();
            })
            .catch((reason: any) => {
                reject(reason);
            });
    });
};
